import client from '../../providers/fetchClient'

export const getUnionTypes = () => client.get('/v3/union-types')
